import React from 'react';
import { Accordion } from '../../../base/Accordion';
import { Badge } from '../../../base';

interface GenericApprovalCardProps {
  functionName: string;
  message?: string;
  functionArguments?: Record<string, unknown>;
  footer?: React.ReactNode;
  defaultOpen?: boolean;
}

/** 메일 외 도구(스킬 스크립트 등)의 승인 요청 범용 카드 */
export const GenericApprovalCard: React.FC<GenericApprovalCardProps> = ({
  functionName,
  // message,
  functionArguments,
  footer,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);

  const Label = (
    <div className="card-label">
      <Badge accent="normal">요청</Badge>
      <div className="tool-name">{`${functionName} 실행 승인 요청`}</div>
    </div>
  );

  const Contents = (
    <div className="mail-approval-card-body">
      <div className="mail-approval-meta">
        <div className="mail-approval-meta-row">
          <span className="mail-approval-meta-label">기능</span>
          <span className="mail-approval-meta-value">{functionName}</span>
        </div>
      </div>
      {functionArguments && Object.keys(functionArguments).length > 0 && (
        <pre className="mail-approval-body">{JSON.stringify(functionArguments, null, 2)}</pre>
      )}
    </div>
  );

  return (
    <div className="msg-content">
      <div className="tool-result">
        <div className="result-card">
          <Accordion
            data={[{ content: Contents, icon: '', label: Label, value: 'generic-approval' }]}
            isMultiple={true}
            defaultValue={[isOpen ? 'generic-approval' : '']}
            onChange={() => {
              setIsOpen((v) => !v);
            }}
          />
          {footer}
        </div>
      </div>
    </div>
  );
};
